var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotfound = function SvgNotfound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25h44v26.172a6.828 6.828 0 0 1-6.828 6.828H17.828A6.828 6.828 0 0 1 11 45.422V19.25Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.107 1.262a3.414 3.414 0 0 1 3.787 0l21.725 14.484C59.429 17.619 58.103 22 54.725 22h-43.45c-3.378 0-4.704-4.38-1.894-6.254L31.107 1.262Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.008 27.5a1.66 1.66 0 0 0-1.66 1.66V33h-3.935a1.66 1.66 0 0 0-1.66 1.66v2.18c0 .917.744 1.66 1.66 1.66h3.935v3.935c0 .916.743 1.66 1.66 1.66h2.18a1.66 1.66 0 0 0 1.66-1.66V38.5h3.841a1.66 1.66 0 0 0 1.66-1.66v-2.18a1.66 1.66 0 0 0-1.66-1.66h-3.84v-3.84a1.66 1.66 0 0 0-1.66-1.66h-2.181Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.316 40.303H69.58V52.95a3.3 3.3 0 0 1-3.3 3.3H51.616a3.3 3.3 0 0 1-3.3-3.3V40.303Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.032 31.61a1.65 1.65 0 0 1 1.83 0l10.5 7c1.357.905.716 3.022-.916 3.022H48.45c-1.633 0-2.273-2.117-.915-3.023l10.498-6.999Z",
    fill: "#B7B7B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.467 44.29a.802.802 0 0 0-.803.802v1.855h-1.901a.802.802 0 0 0-.802.802v1.054c0 .443.359.802.802.802h1.901v1.902c0 .443.36.802.803.802h1.053a.802.802 0 0 0 .802-.802v-1.902h1.856a.802.802 0 0 0 .802-.802V47.75a.802.802 0 0 0-.802-.802h-1.856v-1.855a.802.802 0 0 0-.802-.802h-1.053Z",
    fill: "#F4F4F4"
  })));
};
export default SvgNotfound;